import { serviceConstants } from './service.constants'

const initialState = {
  boatCounters: [],
  filteredBoatCounters: {},
  boatCountersWithLogs: [],
  loadingBoatCountersWithLogs: false,
  boatCountersWithUsage: [],
  refuelCountersForDashboard: [],
  timeCountersForDashboard: [],
  boatCounterTypes: [],
  services: [],
  servicesForEquipment: {},

  loadingServicesOverviewForEquipment: false,
  servicesOverviewForEquipment: null,
  servicesOverviewForEquipmentError: null,

  loadingCounterServicesForDashboard: false,
  counterServicesForDashboard: [],

  loadingTodaysServices: false,
  todaysServices: [],

  loadingServicesWithoutRecurrence: false,
  servicesWithoutRecurrence: [],

  loadingThisWeeksServices: false,
  thisWeeksServices: [],

  loadingThisMonthsServices: false,
  thisMonthsServices: [],

  loadingThisYearsServices: false,
  thisYearsServices: [],

  servicesForDashboard: [],
  loadingServicesForDashboard: false,
  servicesForDashboardError: null,

  loadingCalendarServicesByType: {},
  calendarServicesByType: {},
  calendarServicesForEquipment: {},

  loadingCounterServicesForEquipmentComparison: false,
  counterServicesForEquipmentComparison: [],
  counterServicesForEquipmentComparisonError: null,

  serviceHistoryForBoat: {},
  loadingServiceHistoryForBoat: false,

  createdBoatCounter: {},
  units: [],
  loading: false,
  error: null,
}

export function service(state = initialState, action) {
  switch (action.type) {
    case serviceConstants.FETCH_COUNTERS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        boatCounters: action.boatCounters,
      }
    case serviceConstants.FETCH_FILTERED_COUNTERS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        filteredBoatCounters: {
          ...state.filteredBoatCounters,
          [action.counterType]: action.boatCounters,
        },
      }
    case serviceConstants.FETCH_REFUEL_COUNTERS_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        refuelCountersForDashboard: action.boatCounters,
      }
    case serviceConstants.FETCH_TIME_COUNTERS_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        timeCountersForDashboard: action.boatCounters,
      }
    case serviceConstants.FETCH_COUNTER_SERVICES_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        counterServicesForDashboard: action.counterServicesForDashboard,
      }
    case serviceConstants.FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingBoatCountersWithLogs: true,
      }
    case serviceConstants.FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingBoatCountersWithLogs: false,
        boatCountersWithLogs: action.boatCounters,
      }
    case serviceConstants.FETCH_COUNTERS_WITH_USAGE_FOR_BOAT_SUCCESS:
      return {
        ...state,
        boatCountersWithUsage: action.boatCounters,
      }

    case serviceConstants.FETCH_BOAT_COUNTER_TYPES_SUCCESS:
      return {
        ...state,
        boatCounterTypes: action.boatCounterTypes,
      }

    case serviceConstants.CREATE_BOAT_COUNTER_SUCCESS:
      return {
        ...state,
        loading: false,
        createdBoatCounter: action.boatCounter,
      }

    case serviceConstants.CREATE_BOAT_COUNTER_LOG_SUCCESS: {
      const updatedBoatCounters = state.boatCounters.map((item, index) => {
        if (item.boatCounterId !== action.boatCounterLog.boatCounterId) {
          // This isn't the item we care about - keep it as-is
          return item
        }
        item.boatCounterLogs.unshift(action.boatCounterLog)
        return item
      })
      return {
        ...state,
        boatCounters: updatedBoatCounters,
        loading: false,
      }
    }

    case serviceConstants.CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case serviceConstants.FETCH_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        services: action.services,
      }
    case serviceConstants.FETCH_CALENDAR_SERVICES_LOADING:
      return {
        ...state,
        loadingCalendarServicesByType: {
          ...state.loadingCalendarServicesByType,
          [action.serviceType]: true,
        },
      }
    case serviceConstants.FETCH_CALENDAR_SERVICES_SUCCESS:
      return {
        ...state,
        loadingCalendarServicesByType: {
          ...state.loadingCalendarServicesByType,
          [action.serviceType]: true,
        },
        calendarServicesByType: {
          ...state.calendarServicesByType,
          [action.serviceType]: action.services,
        },
        loading: false,
      }
    case serviceConstants.FETCH_CALENDAR_SERVICES_FOR_EQUIPMENT_SUCCESS:
      return {
        ...state,
        loadingCalendarServicesByType: {
          ...state.loadingCalendarServicesByType,
          [action.serviceType]: true,
        },
        calendarServicesForEquipment: {
          ...state.calendarServicesForEquipment,
          [action.equipmentId]: {
            ...state.calendarServicesForEquipment[action.equipmentId],
            [action.serviceType]: action.services,
          },
        },
        loading: false,
      }
    case serviceConstants.FETCH_CALENDAR_SERVICES_ERROR:
      return {
        ...state,
        loadingCalendarServicesByType: {
          ...state.loadingCalendarServicesByType,
          [action.serviceType]: false,
        },
        error: action.error,
      }
    case serviceConstants.FETCH_UNITS_SUCCESS:
      return {
        ...state,
        loading: false,
        units: action.units,
      }
    case serviceConstants.FETCH_SERVICES_FOR_EQUIPMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        servicesForEquipment: {
          ...state.servicesForEquipment,
          [action.equipmentId]: action.services,
        },
      }
    case serviceConstants.FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_LOADING:
      return {
        ...state,
        loadingServicesOverviewForEquipment: true,
        servicesOverviewForEquipment: null,
      }
    case serviceConstants.FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_SUCCESS:
      return {
        ...state,
        loadingServicesOverviewForEquipment: false,
        servicesOverviewForEquipment: action.services,
      }
    case serviceConstants.FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_ERROR:
      return {
        ...state,
        loadingServicesOverviewForEquipment: false,
        servicesOverviewForEquipmentError: action.error,
      }
    case serviceConstants.FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_LOADING:
      return {
        ...state,
        loadingCounterServicesForEquipmentComparison: true,
      }
    case serviceConstants.FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_SUCCESS:
      return {
        ...state,
        loadingCounterServicesForEquipmentComparison: false,
        counterServicesForEquipmentComparison: action.services,
      }
    case serviceConstants.FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_ERROR:
      return {
        ...state,
        loadingCounterServicesForEquipmentComparison: false,
        counterServicesForEquipmentComparisonError: action.error,
      }
    case serviceConstants.FETCH_SERVICE_HISTORY_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingServiceHistoryForBoat: true,
      }
    case serviceConstants.FETCH_SERVICE_HISTORY_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingServiceHistoryForBoat: false,
        serviceHistoryForBoat: {
          ...state.serviceHistoryForBoat,
          [action.boatId]: action.maintenanceHistory,
        },
      }
    case serviceConstants.FETCH_SERVICE_HISTORY_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingServiceHistoryForBoat: false,
      }
    case serviceConstants.FETCH_SERVICES_FOR_BOAT_DASHBOARD_LOADING:
      return {
        ...state,
        loadingServicesForDashboard: true,
      }
    case serviceConstants.FETCH_SERVICES_FOR_BOAT_DASHBOARD_SUCCESS:
      return {
        ...state,
        loadingServicesForDashboard: false,
        servicesForDashboard: action.services,
      }
    case serviceConstants.FETCH_SERVICES_FOR_BOAT_DASHBOARD_ERROR:
      return {
        ...state,
        loadingServicesForDashboard: false,
        servicesForDashboardError: action.error,
      }
    case serviceConstants.RESET_SERVICES:
      return {
        ...state,
        services: [],
        counterServicesForDashboard: [],
        todaysServices: [],
        thisWeeksServices: [],
      }
    case serviceConstants.REQUEST_START:
      return {
        ...state,
        loading: true,
      }
    case serviceConstants.REQUEST_STOP:
      return {
        ...state,
        loading: false,
      }

    case serviceConstants.REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return {
        ...state,
      }
  }
}
